// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ProfileDetails {
  display: flex;
}
.Profilepic {
  position: absolute;
  top: 85px;
  left: 50px;
  width: 50px;
  height: 50px;
  border-radius: 100%;
  border: 3.5px solid white;
  background-color: #fefefe;
}
.Profilepic > img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
}
.Name {
  margin-top: 10px;
  margin-left: 120px;
}
.username-button {
  padding: 8px 18px;
  /* background-color: #efeeed; */
  border-width: 0px;
  border-radius: 50px;
  outline: none !important;
  /* box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6), -6px -6px 12px rgba(255, 255, 255, 0.5); */
  /* transition: background-color 0.3s ease; */
  background-color: white;
  border: solid 1px #dee0e1;
}
/* .username-button:active {
  background-color: whitesmoke;
} */
.Name h2 {
  padding: 0;
  margin: 0;
  font-weight: 400;
  font-size: 22px !important;
}
.Edit {
  margin-top: 5px;
  margin-left: 20px;
  padding: 5px 10px;
  border: none;
  border-radius: 20px;
  font-size: 12px;
  background-color: #efeeed;
  text-transform: capitalize;
  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),
    -6px -6px 12px rgba(255, 255, 255, 0.5);
  cursor: pointer;
}
.Edit img {
  margin-right: 5px;
}
.Camera {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  position: absolute;
  bottom: 0px;
  left: 85px;
  padding: 6px;
  border-radius: 50%;
  background-color: white;
  border: 1.5px solid #dee0e1;
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);
  cursor: pointer;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}
.Camera:hover {
  transform: scale(1.08);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}
.Camera img {
  width: 20px;
  height: 20px;
  object-fit: contain;
}

@media screen and (min-width: 375px) {
  .Profilepic {
    position: absolute;
    top: 105px;
    left: 50px;
    width: 90px;
    height: 90px;
  }
  .Camera {
    position: absolute;
    bottom: 0px;
    left: 115px;
    padding: 6px;
  }
  .Name {
    margin-top: 10px;
    margin-left: 180px;
  }
  .Name h2 {
    font-size: 16px;
  }
  .Edit {
    margin-top: 10px;
    margin-left: 10px;
    padding: 5px 17px;
    font-size: 12px;
    margin-right: 10px;
  }
}

@media screen and (min-width: 992px) {
  .Profilepic {
    position: absolute;
    top: 125px;
    left: 50px;
    width: 90px;
    height: 90px;
  }
  .Camera {
    left: 115px;
  }
  .Name {
    margin-left: 180px;
  }
  .Name h2 {
    font-size: 20px;
  }
  .Edit {
    margin-left: 10px;
    padding: 5px 17px;
    font-size: 15px;
    margin-right: 10px;
  }
}

@media screen and (min-width: 1024px) {
  .Profilepic {
    position: absolute;
    top: 140px;
    left: 80px;
    width: 125px;
    height: 125px;
  }
  .Camera {
    width: 40px;
    height: 40px;
    bottom: 0px;
    left: 175px;
    border-radius: 50%;
  }
  .Camera img {
    width: 22px;
    height: 22px;
  }
  .Name {
    margin-left: 230px;
    margin-top: 16px;
  }
  .Name h2 {
    font-size: 23px;
  }
  .Edit {
    margin-left: 20px;
    padding: 10px 17px;
    font-size: 15px;
    margin-right: 0;
  }
}

@media screen and (min-width: 1200px) {
  .ProfileDetails {
    margin-left: 110px;
  }
  .Profilepic {
    position: absolute;
    top: 140px;
    left: 170px;
    width: 135px;
    height: 135px;
  }
  .Camera {
    width: 42px;
    height: 42px;
    bottom: -10px;
    left: 275px;
    border-radius: 50%;
  }
  .Camera img {
    width: 23px;
    height: 23px;
  }
  .Name {
    margin-left: 230px;
    margin-top: 16px;
  }
  .Name h2 {
    font-size: 23px;
  }
  .Edit {
    margin-left: 20px;
    padding: 10px 17px;
    font-size: 15px;
    margin-right: 0;
  }
}

@media screen and (min-width: 1440px) {
  .ProfileDetails {
    margin-left: 230px;
  }
  .Profilepic {
    position: absolute;
    top: 110px;
    left: 275px;
    width: 155px;
    height: 155px;
  }
  .Camera {
    width: 44px;
    height: 44px;
    bottom: -10px;
    left: 390px;
    border-radius: 50%;
  }
  .Camera img {
    width: 24px;
    height: 24px;
  }
  .Name {
    margin-left: 230px;
    margin-top: 16px;
  }
  .Name h2 {
    font-size: 28px;
  }
  .Edit {
    margin-left: 20px;
    padding: 10px 17px;
    font-size: 18px;
    margin-right: 0;
  }
}

@media screen and (min-width: 1600px) {
  .ProfileDetails {
    margin-left: 288px;
  }
  .Profilepic {
    position: absolute;
    top: 136px;
    left: 325px;
    width: 170px;
    height: 170px;
  }
  .Camera {
    width: 46px;
    height: 46px;
    bottom: -2px;
    left: 450px;
    border-radius: 50%;
  }
  .Camera img {
    width: 25px;
    height: 25px;
  }
  .Name {
    margin-left: 230px;
    margin-top: 16px;
  }
  .Name h2 {
    font-size: 38px;
  }
  .Edit {
    margin-left: 20px;
    padding: 10px 17px;
    font-size: 25px;
    margin-right: 0;
  }
}

@media screen and (min-width: 1800px) {
  .ProfileDetails {
    margin: auto;
  }
  .Profilepic {
    position: absolute;
    top: 136px;
    left: auto;
    width: 200px;
    height: 200px;
  }
  .Camera {
    width: 48px;
    height: 48px;
    bottom: -2px;
    left: auto;
    border-radius: 50%;
    margin-left: 170px;
  }
  .Camera img {
    width: 26px;
    height: 26px;
  }
  .Name {
    margin-left: 230px;
    margin-top: 10px;
  }
  .Name h2 {
    font-size: 48px;
  }
  .Edit {
    margin-left: 20px;
    padding: 10px 17px;
    font-size: 28px;
    margin-right: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Modules/Activity/Profile/ProfileDetails/ProfileDetails.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,iBAAiB;EACjB,mBAAmB;EACnB,wBAAwB;EACxB,8FAA8F;EAC9F,4CAA4C;EAC5C,uBAAuB;EACvB,yBAAyB;AAC3B;AACA;;GAEG;AACH;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,0BAA0B;EAC1B;2CACyC;EACzC,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,2BAA2B;EAC3B,2CAA2C;EAC3C,eAAe;EACf,qDAAqD;AACvD;AACA;EACE,sBAAsB;EACtB,2CAA2C;AAC7C;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,WAAW;IACX,YAAY;EACd;EACA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;EACpB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,YAAY;IACZ,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,YAAY;IACZ,aAAa;EACf;EACA;IACE,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,kBAAkB;EACpB;EACA;IACE,WAAW;IACX,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;AACF","sourcesContent":[".ProfileDetails {\r\n  display: flex;\r\n}\r\n.Profilepic {\r\n  position: absolute;\r\n  top: 85px;\r\n  left: 50px;\r\n  width: 50px;\r\n  height: 50px;\r\n  border-radius: 100%;\r\n  border: 3.5px solid white;\r\n  background-color: #fefefe;\r\n}\r\n.Profilepic > img {\r\n  width: 100%;\r\n  height: 100%;\r\n  border-radius: 100%;\r\n}\r\n.Name {\r\n  margin-top: 10px;\r\n  margin-left: 120px;\r\n}\r\n.username-button {\r\n  padding: 8px 18px;\r\n  /* background-color: #efeeed; */\r\n  border-width: 0px;\r\n  border-radius: 50px;\r\n  outline: none !important;\r\n  /* box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6), -6px -6px 12px rgba(255, 255, 255, 0.5); */\r\n  /* transition: background-color 0.3s ease; */\r\n  background-color: white;\r\n  border: solid 1px #dee0e1;\r\n}\r\n/* .username-button:active {\r\n  background-color: whitesmoke;\r\n} */\r\n.Name h2 {\r\n  padding: 0;\r\n  margin: 0;\r\n  font-weight: 400;\r\n  font-size: 22px !important;\r\n}\r\n.Edit {\r\n  margin-top: 5px;\r\n  margin-left: 20px;\r\n  padding: 5px 10px;\r\n  border: none;\r\n  border-radius: 20px;\r\n  font-size: 12px;\r\n  background-color: #efeeed;\r\n  text-transform: capitalize;\r\n  box-shadow: 5px 5px 8px rgb(163, 177, 198, 0.6),\r\n    -6px -6px 12px rgba(255, 255, 255, 0.5);\r\n  cursor: pointer;\r\n}\r\n.Edit img {\r\n  margin-right: 5px;\r\n}\r\n.Camera {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  width: 36px;\r\n  height: 36px;\r\n  position: absolute;\r\n  bottom: 0px;\r\n  left: 85px;\r\n  padding: 6px;\r\n  border-radius: 50%;\r\n  background-color: white;\r\n  border: 1.5px solid #dee0e1;\r\n  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.15);\r\n  cursor: pointer;\r\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\r\n}\r\n.Camera:hover {\r\n  transform: scale(1.08);\r\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);\r\n}\r\n.Camera img {\r\n  width: 20px;\r\n  height: 20px;\r\n  object-fit: contain;\r\n}\r\n\r\n@media screen and (min-width: 375px) {\r\n  .Profilepic {\r\n    position: absolute;\r\n    top: 105px;\r\n    left: 50px;\r\n    width: 90px;\r\n    height: 90px;\r\n  }\r\n  .Camera {\r\n    position: absolute;\r\n    bottom: 0px;\r\n    left: 115px;\r\n    padding: 6px;\r\n  }\r\n  .Name {\r\n    margin-top: 10px;\r\n    margin-left: 180px;\r\n  }\r\n  .Name h2 {\r\n    font-size: 16px;\r\n  }\r\n  .Edit {\r\n    margin-top: 10px;\r\n    margin-left: 10px;\r\n    padding: 5px 17px;\r\n    font-size: 12px;\r\n    margin-right: 10px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 992px) {\r\n  .Profilepic {\r\n    position: absolute;\r\n    top: 125px;\r\n    left: 50px;\r\n    width: 90px;\r\n    height: 90px;\r\n  }\r\n  .Camera {\r\n    left: 115px;\r\n  }\r\n  .Name {\r\n    margin-left: 180px;\r\n  }\r\n  .Name h2 {\r\n    font-size: 20px;\r\n  }\r\n  .Edit {\r\n    margin-left: 10px;\r\n    padding: 5px 17px;\r\n    font-size: 15px;\r\n    margin-right: 10px;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1024px) {\r\n  .Profilepic {\r\n    position: absolute;\r\n    top: 140px;\r\n    left: 80px;\r\n    width: 125px;\r\n    height: 125px;\r\n  }\r\n  .Camera {\r\n    width: 40px;\r\n    height: 40px;\r\n    bottom: 0px;\r\n    left: 175px;\r\n    border-radius: 50%;\r\n  }\r\n  .Camera img {\r\n    width: 22px;\r\n    height: 22px;\r\n  }\r\n  .Name {\r\n    margin-left: 230px;\r\n    margin-top: 16px;\r\n  }\r\n  .Name h2 {\r\n    font-size: 23px;\r\n  }\r\n  .Edit {\r\n    margin-left: 20px;\r\n    padding: 10px 17px;\r\n    font-size: 15px;\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1200px) {\r\n  .ProfileDetails {\r\n    margin-left: 110px;\r\n  }\r\n  .Profilepic {\r\n    position: absolute;\r\n    top: 140px;\r\n    left: 170px;\r\n    width: 135px;\r\n    height: 135px;\r\n  }\r\n  .Camera {\r\n    width: 42px;\r\n    height: 42px;\r\n    bottom: -10px;\r\n    left: 275px;\r\n    border-radius: 50%;\r\n  }\r\n  .Camera img {\r\n    width: 23px;\r\n    height: 23px;\r\n  }\r\n  .Name {\r\n    margin-left: 230px;\r\n    margin-top: 16px;\r\n  }\r\n  .Name h2 {\r\n    font-size: 23px;\r\n  }\r\n  .Edit {\r\n    margin-left: 20px;\r\n    padding: 10px 17px;\r\n    font-size: 15px;\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1440px) {\r\n  .ProfileDetails {\r\n    margin-left: 230px;\r\n  }\r\n  .Profilepic {\r\n    position: absolute;\r\n    top: 110px;\r\n    left: 275px;\r\n    width: 155px;\r\n    height: 155px;\r\n  }\r\n  .Camera {\r\n    width: 44px;\r\n    height: 44px;\r\n    bottom: -10px;\r\n    left: 390px;\r\n    border-radius: 50%;\r\n  }\r\n  .Camera img {\r\n    width: 24px;\r\n    height: 24px;\r\n  }\r\n  .Name {\r\n    margin-left: 230px;\r\n    margin-top: 16px;\r\n  }\r\n  .Name h2 {\r\n    font-size: 28px;\r\n  }\r\n  .Edit {\r\n    margin-left: 20px;\r\n    padding: 10px 17px;\r\n    font-size: 18px;\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1600px) {\r\n  .ProfileDetails {\r\n    margin-left: 288px;\r\n  }\r\n  .Profilepic {\r\n    position: absolute;\r\n    top: 136px;\r\n    left: 325px;\r\n    width: 170px;\r\n    height: 170px;\r\n  }\r\n  .Camera {\r\n    width: 46px;\r\n    height: 46px;\r\n    bottom: -2px;\r\n    left: 450px;\r\n    border-radius: 50%;\r\n  }\r\n  .Camera img {\r\n    width: 25px;\r\n    height: 25px;\r\n  }\r\n  .Name {\r\n    margin-left: 230px;\r\n    margin-top: 16px;\r\n  }\r\n  .Name h2 {\r\n    font-size: 38px;\r\n  }\r\n  .Edit {\r\n    margin-left: 20px;\r\n    padding: 10px 17px;\r\n    font-size: 25px;\r\n    margin-right: 0;\r\n  }\r\n}\r\n\r\n@media screen and (min-width: 1800px) {\r\n  .ProfileDetails {\r\n    margin: auto;\r\n  }\r\n  .Profilepic {\r\n    position: absolute;\r\n    top: 136px;\r\n    left: auto;\r\n    width: 200px;\r\n    height: 200px;\r\n  }\r\n  .Camera {\r\n    width: 48px;\r\n    height: 48px;\r\n    bottom: -2px;\r\n    left: auto;\r\n    border-radius: 50%;\r\n    margin-left: 170px;\r\n  }\r\n  .Camera img {\r\n    width: 26px;\r\n    height: 26px;\r\n  }\r\n  .Name {\r\n    margin-left: 230px;\r\n    margin-top: 10px;\r\n  }\r\n  .Name h2 {\r\n    font-size: 48px;\r\n  }\r\n  .Edit {\r\n    margin-left: 20px;\r\n    padding: 10px 17px;\r\n    font-size: 28px;\r\n    margin-right: 0;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
